import { Notificacao } from './notificacao';

export class NotificacaoDestino {
  id: number;
  fkServidor: number;
  snAtivo: string;
  dtVisualizacao: Date;
  dtIgnorado: Date;
  dtResposta: Date;
  dsResposta: string;
  snMultipla: string;
  notificacao: Notificacao;

  public static createInstance(dados: {}): NotificacaoDestino {
    const item: NotificacaoDestino = new NotificacaoDestino();
    Object.assign(item, dados);
    return item;
  }
}
